export default "__VITE_ASSET__BuuYEwYF__"